import { useState } from "react";
import { Collapse, StepContent, StepLabel, Stepper, Typography } from "@mui/material";

//API

//SERVICES
import { GetByIdPackingTrackingResponse, IHistory } from "@/main/models/response/packingTrackingHistoryResponse";
import { getTranslateByKey } from "@/main/services/utils";
import { userIsAdmin, userIsSupplier } from "@/main/services/utilsUser";

//COMPONENTS
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import LoadingComponent from "@/main/components/shared/loading/loadingComponent";

import * as S from "./styles";
import { OrderStatusEnum } from "@/main/services/enum/OrderStatusEnum";
import { handleDownloadPDf, handleDownloadZPL } from "../../infoOrder/utilsInfoOrder";

function getSteps() {
	return [getTranslateByKey("procurementstatus.transit"), getTranslateByKey("procurementstatus.delivered")];
}

interface SeeShippingDetails {
	isLoadingDataSeeShippingDetails: boolean;
	checked: boolean;
	dataSeeShippingDetails: GetByIdPackingTrackingResponse[];
	trackingNumber: string;
}

function SeeShippingDetails({
	isLoadingDataSeeShippingDetails,
	checked,
	dataSeeShippingDetails,
	trackingNumber,
}: SeeShippingDetails) {
	getSteps();
	const [loadingZpl, setLoadingZpl] = useState<boolean>(false);
	const [loadingPdf, setLoadingPdf] = useState<boolean>(false);

	const isAdmin = userIsAdmin();
	const isSupplier = userIsSupplier();

	function renderHistory(list: IHistory) {
		let historyText = `${list.historyDateFormatted} - ${list.description}`;
		if (list.additionalInformation) {
			historyText += `(${list.additionalInformation})`;
		}
		return historyText;
	}

	if (isLoadingDataSeeShippingDetails) return <LoadingComponent />;

	return (
		<>
			<S.Container>
				<div>
					<Collapse in={checked}>
						<Stepper orientation="vertical">
							{dataSeeShippingDetails.map((option, key) => (
								<S.ContainerStep
									lastStep={option.idProcurementStatus != OrderStatusEnum.Delivered}
									active={true}
									key={key}
									className="TesteStep"
								>
									<StepLabel>{option.procurementStatusDescription}</StepLabel>
									<StepContent>
										<S.BoxSeeShippingDetails>
											{option.history.map((list: IHistory, index) => (
												<Typography key={index}>{renderHistory(list)}</Typography>
											))}
										</S.BoxSeeShippingDetails>
									</StepContent>
								</S.ContainerStep>
							))}
						</Stepper>

						{(isSupplier || isAdmin) && dataSeeShippingDetails.length === OrderStatusEnum.Assigned && (
							<S.ContainerButton>
								<SecondaryButton
									type="button"
									onClick={() => handleDownloadPDf(trackingNumber, setLoadingPdf)}
									id="id-searchOrders-button-printPdf"
									isLoading={loadingPdf}
								>
									{getTranslateByKey("packingTrackingHistory.printTagPDF")}
								</SecondaryButton>
								<SecondaryButton
									type="button"
									onClick={() => handleDownloadZPL(trackingNumber, setLoadingZpl)}
									id="id-searchOrders-button-printZpl"
									isLoading={loadingZpl}
								>
									{getTranslateByKey("packingTrackingHistory.printTagZPL")}
								</SecondaryButton>
							</S.ContainerButton>
						)}
					</Collapse>
				</div>
			</S.Container>
		</>
	);
}

export default SeeShippingDetails;
